import Vue from "vue";

function initialState() {
  return {};
}

const state = initialState();

const actions = {
     loadActivityTypes: async function(context) {
    
       let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "/api/activity/activitytypes"
    ).catch(err => err.response);
    return response && response.data 
      ? response.data
      : null;
  },  
  loadActionTypes: async function(context) {
    
       let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "/api/activity/actiontypes"
    ).catch(err => err.response);
    return response && response.data
      ? response.data
      : null;
  },


};

const mutations = {};

const getters = {};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/ActivityAction.js